(function () {
  function initAutoCarousels() {
    document.querySelectorAll('[data-auto-carousel]').forEach(function (carousel) {

      let scrollAmount = 0;
      const interval = 2000;

      function autoScroll() {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;

        if (maxScroll <= 0) return; // nothing to scroll

        // Scroll by ~1 image width
        const step = carousel.querySelector('img')?.offsetWidth || 300;

        scrollAmount += step + 16; // include gap

        if (scrollAmount >= maxScroll) {
          scrollAmount = 0;
        }

        carousel.scrollTo({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }

      setInterval(autoScroll, interval);
    });
  }

  document.addEventListener('DOMContentLoaded', initAutoCarousels);
})();
